<template>
  <v-layout column v-if="!loading">
    <h1 v-if="title" class="title">{{ title }}</h1>
    <v-img v-if="image" class="image" width="100%" min-height="400px" :src="image.src" :alt="image.alt"></v-img>
    <ul class="metadata">
      <li v-for="(item, index) in metadata" :key="index">
        <strong class="metadata-text">{{ $t('message.metadata.' + item.text) }}:</strong>
        <span class="metadata-value">{{ item.value|formatDate }}</span>
      </li>
    </ul>
    <div v-if="body" class="body" v-html="body"></div>
  </v-layout>
  <v-layout column v-else >
    <skeleton-loader class="title ml-3" width="80%" :height="20" animation="fade"/>
    <skeleton-loader class="image" width="100%" :height="400" animation="fade"/>
    <skeleton-loader class="metadata ml-3" width="30%" :height="14" animation="fade"/>
    <skeleton-loader class="body ml-3" width="90%" :height="200" animation="fade"/>
  </v-layout>
</template>

<script>
import apiFactory from '../api';
import SkeletonLoader from '@/components/skeleton/SkeletonLoader';

export default {
  name: 'nx-entity-preview',
  components: {
    SkeletonLoader,
  },
  props: {
    id: {
      type: Number,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: true,
      title: null,
      metadata: [],
      image: null,
      body: null,
    };
  },
  methods: {
    reset() {
      this.title = null;
      this.metadata = [];
      this.image = null;
      this.body = null;
      this.loading = true;
    },
    async init() {
      try {
        const api = apiFactory(this.type);
        const { preview } = await api.preview(this.id);
        this.title = preview.title;
        this.metadata = preview.metadata || [];
        this.image = preview.image || null;
        this.body = preview.body;
        this.loading = false;
      } catch (err) {
        console.error(err);
        this.toast.notify('message.error.serverError');
      }
    },
  },
  watch: {
    type() {
      this.reset();
      this.init();
    },
    id() {
      this.reset();
      this.init();
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style lang="stylus" scoped>
.title {
  font-size: 20px;
  font-weight: 500;
  color: black;
  padding: 0 20px;
  margin-top: 20px;
}

.image {
  margin-top: 20px;
}

.metadata {
  font-size: 14px;
  margin-top: 20px;
  color: #41414e;
  padding: 0 20px;
  list-style: none;
  &-value {
    margin-left: 4px;
  }
}

.body {
  font-size: 14px;
  margin-top: 20px;
  color: #41414e;
  padding: 0 20px;
}
</style>
